import React from 'react'
// import FAQ from '../component/FAQ'
import { useParams } from "react-router-dom";
import ServiceData from '../Dataservices/dataservices';
// import Servivefaq from '../component/servicefaq';
import Doks from '../component/Doks';
const Services = () => {
    const { id } = useParams(); // Get the service name from the URL
    const service = ServiceData[id];
    console.log("service", service); // Get the corresponding service data
    if (!service) {
        return <h2>Service not found</h2>; // Handle case where service is not found
    }
    const firstHalf = service.KeyBenefits.points.slice(0, Math.ceil(service.KeyBenefits.points.length / 2));
    const secondHalf = service.KeyBenefits.points.slice(Math.ceil(service.KeyBenefits.points.length / 2));
    // console.log("jfjsdf",firstHalf,secondHalf)
    return (
        <div
            data-elementor-type="wp-page"
            data-elementor-id="18"
            className="elementor elementor-18"
        >
            <div
                className="qodef-page-title qodef-m qodef-title--breadcrumbs qodef-alignment--left qodef-vertical-alignment--header-bottom"
                style={{
                    backgroundImage: `linear-gradient(to top, rgba(30, 73, 125, 100%), rgba(96,96,96, 0)),url(${service?.image})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: `${service?.backgroundPosition}`,
                    backgroundSize: 'cover',
                    position: 'relative',
                }}
            >
                {/* Overlay Div */}
                {/* <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)', // Adjust color and opacity
                }}></div> */}

                {/* Content */}
                {/* <div className="qodef-m-inner" style={{ position: 'relative', zIndex: 1 }}>
                    <div className="qodef-m-content qodef-content-grid ">
                        <div itemProp="breadcrumb" className="qodef-breadcrumbs">
                            <a itemProp="url" className="qodef-breadcrumbs-link" href="/" style={{ color: "#fff" }}>
                                <span itemProp="title">Home</span>
                            </a>
                            <span className="qodef-breadcrumbs-separator" style={{ color: "#fff" }} />
                            <span itemProp="title" className="qodef-breadcrumbs-current" style={{ color: "#fff" }}>
                                Projects Management
                            </span>
                        </div>
                    </div>
                </div> */}
                <div className="qodef-m-content qodef-content-grid" style={{ width: '100%', textAlign: 'left', padding: '0 20px' }}>
                    {/* Breadcrumb Navigation */}
                    <div itemProp="breadcrumb" className="qodef-breadcrumbs" style={{ color: "#fff", margin: "11px 88px -226px 34px" }}>
                        <a itemProp="url" className="qodef-breadcrumbs-link" href="/" style={{ color: "#fff", textDecoration: "none" }}>
                            <span itemProp="title">Home</span>
                        </a>
                        {/* <span className="qodef-breadcrumbs-separator" style={{ margin: "0 10px", color: "#fff" }}> &gt; </span> */}
                        {/* <a itemProp="url" className="qodef-breadcrumbs-link" href="/server" style={{ color: "#fff", textDecoration: "none" }}>
                <span itemProp="title">Server</span>
            </a> */}
                        <span className="qodef-breadcrumbs-separator" style={{ margin: "0 10px", color: "#fff" }}> </span>
                        <span itemProp="title" className="qodef-breadcrumbs-current" style={{ color: "#fff" }}>
                            {service.crum}
                        </span>
                    </div>
                </div>
            </div>


            {/* <div className="qodef-page-title qodef-m qodef-title--standard qodef-alignment--left qodef-vertical-alignment--header-bottom qodef--has-image" style={{
                backgroundImage: `url(${service?.image})`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                backgroundSize: 'cover',
            }}>
                <div className="qodef-m-inner">
                    <div className="qodef-m-content qodef-content-grid ">
                        <h1 className="qodef-m-title entry-title">About Us </h1>
                    </div>
                </div>
            </div> */}
            {/* e-con-full */}
            <div
                className="elementor-element elementor-element-3b1c742  qodef-elementor-content-grid e-flex e-con e-parent mobi-serv"
                data-id="3b1c742"
                data-element_type="container"
                style={{ marginTop: "61px" }}
            >
                <div
                    className="elementor-element elementor-element-5386d30 e-con-full e-flex e-con e-child"
                    data-id="5386d30"
                    data-element_type="container"
                >
                    <div
                        className="elementor-element elementor-element-ad3d20d elementor-widget elementor-widget-startpro_core_section_title"
                        data-id="ad3d20d"
                        data-element_type="widget"
                        data-widget_type="startpro_core_section_title.default"
                    >
                        <div className="elementor-widget-container">
                            <div className="qodef-shortcode qodef-m  qodef-section-title qodef-alignment--left " data-aos="fade-right" data-aos-duration="600" data-aos-easing="ease-out">
                                <p style={{ fontSize: "16px", marginBottom: "10px" }}> {service.crum}
                                </p>
                                <h2 className="qodef-m-title">
                                    {service.title}
                                </h2>
                            </div>
                        </div>
                    </div>

                </div>
                <div
                    className="elementor-element elementor-element-645a6e1 e-con-full e-flex e-con e-child"
                    data-id="645a6e1"
                    data-element_type="container"
                >

                    <div
                        className="elementor-element elementor-element-db50601 e-con-full e-flex e-con e-child"
                        data-id="db50601"
                        data-element_type="container"
                        data-aos="fade-left" data-aos-duration="600" data-aos-easing="ease-out"
                    >
                        <p>{service.description}</p>
                    </div>
                    <div
                        className="elementor-element elementor-element-a40582d e-con-full e-flex e-con e-child italic-title"
                        data-id="a40582d"
                        data-element_type="container"
                        style={{ "--padding-bottom": "0px", fontWeight: "500" }}
                        data-aos="fade-left" data-aos-duration="600" data-aos-easing="ease-out"
                    >
                        <p>"{service.subtitle}"</p>
                    </div>
                </div>
            </div>
            <Doks faqs={service.consultancy} />
            {/* <Servivefaq faqs={service.consultancy} /> */}
            <div
                className="elementor-element elementor-element-15384c4 e-con-full qodef-elementor-content-grid e-flex e-con e-parent e-lazyloaded"
                data-id="15384c4"
                data-element_type="container"
            >
                <div
                    className="elementor-element elementor-element-66d4fbd e-con-full e-flex e-con e-child"
                    data-id="66d4fbd"
                    data-element_type="container"
                >
                    <div
                        className="elementor-element elementor-element-fa33380 elementor-widget elementor-widget-startpro_core_section_title"
                        data-id="fa33380"
                        data-element_type="widget"
                        data-widget_type="startpro_core_section_title.default"
                    >
                        <div className="elementor-widget-container">
                            <div className="qodef-shortcode qodef-m  qodef-section-title qodef-alignment--left ">
                                <h2 className="qodef-m-title" data-aos="fade-right"
                                    data-aos-duration="3000">
                                    {service.KeyBenefits.title}
                                    {" "}
                                </h2>
                                {/* <span className="qodef-m-description" style={{ marginTop: 15 }}>
                                    PMC Oman has played a pivotal role in advising and managing landmark projects that have reshaped industries. Our portfolio reflects the breadth of our expertise.{" "}
                                </span> */}
                            </div>
                        </div>
                    </div>
                    <div
                        className="elementor-element elementor-element-57280fa e-con-full e-flex e-con e-child"
                        data-id="57280fa"
                        data-element_type="container"
                    >

                        <div
                            className="elementor-element elementor-element-0dfdeba e-con-full e-flex e-con e-child"
                            data-id="0dfdeba"
                            data-element_type="container"

                        >
                            {firstHalf.map((list, index) => (
                                <div
                                    className="elementor-element elementor-element-3592f6d elementor-widget elementor-widget-startpro_core_icon_list_item"
                                    data-id="3592f6d"
                                    data-element_type="widget"
                                    data-widget_type="startpro_core_icon_list_item.default"
                                    key={index}
                                >
                                    <div className="elementor-widget-container">
                                        <div className="qodef-icon-list-item qodef-icon--icon-pack  hover-icon-bounce">
                                            <span className="qodef-e-title" style={{ color: "#0B253F" }}>
                                                <span className="qodef-e-title-inner">
                                                    <span data-aos="fade-right"
                                                        data-aos-duration="3000"
                                                        className="qodef-shortcode qodef-m  qodef-icon-holder  qodef-layout--circle cms-eicon"
                                                    style={{
                                                        margin: "0px 13px 0px 0px",
                                                        width: 26,
                                                        height: 26,
                                                        lineHeight: 26,
                                                        backgroundColor: "#1e497d45"
                                                    }}
                                                    >
                                                        {" "}
                                                        <span
                                                            className="qodef-icon-elegant-icons icon_check qodef-icon qodef-e"
                                                            style={{ color: "#144443" }}
                                                        />{" "}
                                                    </span>{" "}
                                                    <span className="qodef-e-title-text" style={{ fontSize: "14px" }}>{list.title}
                                                    </span>
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {/* <div
                                    className="elementor-element elementor-element-ddbfa9c elementor-widget elementor-widget-startpro_core_icon_list_item"
                                    data-id="ddbfa9c"
                                    data-element_type="widget"
                                    data-widget_type="startpro_core_icon_list_item.default"
                                >
                                    <div className="elementor-widget-container">
                                        <div className="qodef-icon-list-item qodef-icon--icon-pack  ">
                                            <span className="qodef-e-title" style={{ color: "#0B253F" }}>
                                                <span className="qodef-e-title-inner">
                                                    <span
                                                        className="qodef-shortcode qodef-m  qodef-icon-holder  qodef-layout--circle"
                                                        style={{
                                                            margin: "0px 13px 0px 0px",
                                                            width: 26,
                                                            height: 26,
                                                            lineHeight: 26,
                                                            backgroundColor: "#DDE9E8"
                                                        }}
                                                    >
                                                        {" "}
                                                        <span
                                                            className="qodef-icon-elegant-icons icon_check qodef-icon qodef-e"
                                                            style={{ color: "#144443" }}
                                                        />{" "}
                                                    </span>{" "}
                                                    <span className="qodef-e-title-text" style={{ fontSize: "14px" }}>Investment Strategy & Risk Management for Infrastructure Development
                                                    </span>
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                </div> */}
                            {/* <div
        className="elementor-element elementor-element-ed2a040 elementor-widget elementor-widget-startpro_core_icon_list_item"
        data-id="ed2a040"
        data-element_type="widget"
        data-widget_type="startpro_core_icon_list_item.default"
    >
        <div className="elementor-widget-container">
            <div className="qodef-icon-list-item qodef-icon--icon-pack  ">
                <span className="qodef-e-title" style={{ color: "#0B253F" }}>
                    <span className="qodef-e-title-inner">
                        <span
                            className="qodef-shortcode qodef-m  qodef-icon-holder  qodef-layout--circle"
                            style={{
                                margin: "0px 13px 0px 0px",
                                width: 26,
                                height: 26,
                                lineHeight: 26,
                                backgroundColor: "#DDE9E8"
                            }}
                        >
                            {" "}
                            <span
                                className="qodef-icon-elegant-icons icon_check qodef-icon qodef-e"
                                style={{ color: "#144443" }}
                            />{" "}
                        </span>{" "}
                        <span className="qodef-e-title-text" style={{ fontSize: "14px" }}>Consulting for Large-Scale Hospitality & Commercial Projects
                        </span>
                    </span>
                </span>
            </div>
        </div>
    </div> */}

                        </div>


                        <div
                            className="elementor-element elementor-element-77ef1e8 e-con-full e-flex e-con e-child"
                            data-id="77ef1e8"
                            data-element_type="container"
                        >
                            {secondHalf.map((list, index) => (
                                <div
                                    className="elementor-element elementor-element-fa914ec elementor-widget elementor-widget-startpro_core_icon_list_item"
                                    data-id="fa914ec"
                                    data-element_type="widget"
                                    data-widget_type="startpro_core_icon_list_item.default"
                                    key={index}
                                >
                                    <div className="elementor-widget-container">
                                        <div className="qodef-icon-list-item qodef-icon--icon-pack hover-icon-bounce ">
                                            <span className="qodef-e-title" style={{ color: "#0B253F" }}>
                                                <span className="qodef-e-title-inner">
                                                    <span
                                                          className="qodef-shortcode qodef-m  qodef-icon-holder  qodef-layout--circle cms-eicon"
                                                          style={{
                                                              margin: "0px 13px 0px 0px",
                                                              width: 26,
                                                              height: 26,
                                                              lineHeight: 26,
                                                              backgroundColor: "#1e497d45"
                                                          }}
                                                    >
                                                        {" "}
                                                        <span
                                                            className="qodef-icon-elegant-icons icon_check qodef-icon qodef-e"
                                                            style={{ color: "#144443" }}
                                                        />{" "}
                                                    </span>{" "}
                                                    <span className="qodef-e-title-text" style={{ fontSize: "14px" }}>{list.title}
                                                    </span>
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                </div>))}
                            {/* <div
                                className="elementor-element elementor-element-ed2a040 elementor-widget elementor-widget-startpro_core_icon_list_item"
                                data-id="ed2a040"
                                data-element_type="widget"
                                data-widget_type="startpro_core_icon_list_item.default"
                            >
                                <div className="elementor-widget-container">
                                    <div className="qodef-icon-list-item qodef-icon--icon-pack  ">
                                        <span className="qodef-e-title" style={{ color: "#0B253F" }}>
                                            <span className="qodef-e-title-inner">
                                                <span
                                                    className="qodef-shortcode qodef-m  qodef-icon-holder  qodef-layout--circle"
                                                    style={{
                                                        margin: "0px 13px 0px 0px",
                                                        width: 26,
                                                        height: 26,
                                                        lineHeight: 26,
                                                        backgroundColor: "#DDE9E8"
                                                    }}
                                                >
                                                    {" "}
                                                    <span
                                                        className="qodef-icon-elegant-icons icon_check qodef-icon qodef-e"
                                                        style={{ color: "#144443" }}
                                                    />{" "}
                                                </span>{" "}
                                                <span className="qodef-e-title-text" style={{ fontSize: "14px" }}>Consulting for Large-Scale Hospitality & Commercial Projects
                                                </span>
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div> */}
                            {/* <div
                                                        className="elementor-element elementor-element-fa233ee elementor-widget elementor-widget-startpro_core_icon_list_item"
                                                        data-id="fa233ee"
                                                        data-element_type="widget"
                                                        data-widget_type="startpro_core_icon_list_item.default"
                                                    >
                                                        <div className="elementor-widget-container">
                                                            <div className="qodef-icon-list-item qodef-icon--icon-pack  ">
                                                                <span className="qodef-e-title" style={{ color: "#0B253F" }}>
                                                                    <span className="qodef-e-title-inner">
                                                                        <span
                                                                            className="qodef-shortcode qodef-m  qodef-icon-holder  qodef-layout--circle"
                                                                            style={{
                                                                                margin: "0px 13px 0px 0px",
                                                                                width: 26,
                                                                                height: 26,
                                                                                lineHeight: 26,
                                                                                backgroundColor: "#DDE9E8"
                                                                            }}
                                                                        >
                                                                            {" "}
                                                                            <span
                                                                                className="qodef-icon-elegant-icons icon_check qodef-icon qodef-e"
                                                                                style={{ color: "#144443" }}
                                                                            />{" "}
                                                                        </span>{" "}
                                                                        <span className="qodef-e-title-text">Smart Wallet</span>
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        className="elementor-element elementor-element-73fc34e elementor-widget elementor-widget-startpro_core_icon_list_item"
                                                        data-id="73fc34e"
                                                        data-element_type="widget"
                                                        data-widget_type="startpro_core_icon_list_item.default"
                                                    >
                                                        <div className="elementor-widget-container">
                                                            <div className="qodef-icon-list-item qodef-icon--icon-pack  ">
                                                                <span className="qodef-e-title" style={{ color: "#0B253F" }}>
                                                                    <span className="qodef-e-title-inner">
                                                                        <span
                                                                            className="qodef-shortcode qodef-m  qodef-icon-holder  qodef-layout--circle"
                                                                            style={{
                                                                                margin: "0px 13px 0px 0px",
                                                                                width: 26,
                                                                                height: 26,
                                                                                lineHeight: 26,
                                                                                backgroundColor: "#DDE9E8"
                                                                            }}
                                                                        >
                                                                            {" "}
                                                                            <span
                                                                                className="qodef-icon-elegant-icons icon_check qodef-icon qodef-e"
                                                                                style={{ color: "#144443" }}
                                                                            />{" "}
                                                                        </span>{" "}
                                                                        <span className="qodef-e-title-text">Profit Planner</span>
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div> */}
                        </div>
                    </div>
                    <div
                        className="elementor-element elementor-element-7cc4ab3 elementor-widget elementor-widget-startpro_core_button"
                        data-id="7cc4ab3"
                        data-element_type="widget"
                        data-widget_type="startpro_core_button.default"
                    >
                        <div className="elementor-widget-container">
                            <a
                                className="qodef-shortcode qodef-m  qodef-button qodef-layout--filled  qodef-html--link "
                                href="/contact_us"
                                target="_self"
                            >
                                <span className="qodef-m-text">Book consultation</span>
                            </a>
                        </div>
                    </div>
                </div>
                <div
                    className="elementor-element elementor-element-9ab111d e-con-full e-flex e-con e-child"
                    data-id="9ab111d"
                    data-element_type="container"
                >
                    <div
                        className="elementor-element elementor-element-5cfc504 elementor-widget elementor-widget-slider_revolution"
                        data-id="5cfc504"
                        data-element_type="widget"
                        data-widget_type="slider_revolution.default"
                    >
                        <div className="elementor-widget-container sr7t">
                            <div className="wp-block-themepunch-revslider">
                                <sr7-module
                                    data-alias="consulting"
                                    data-id={4}
                                    id="SR7_4_1"
                                    data-version="6.7.25"
                                    style={{ height: 570 }}
                                    data-current={7}
                                >
                                    <sr7-adjuster style={{ height: 570 }} />
                                    <sr7-content style={{ height: 570, left: 0, width: 650, top: 0 }}>
                                        <sr7-slide
                                            id="SR7_4_1-7"
                                            data-key={7}
                                            style={{
                                                pointerEvents: "auto",
                                                visibility: "visible",
                                                display: "block",
                                                zIndex: 5
                                            }}
                                        >
                                            <sr7-mask
                                                style={{
                                                    overflow: "visible",
                                                    minHeight: "auto",
                                                    minWidth: "auto",
                                                    width: "100%",
                                                    height: 570,
                                                    zIndex: 0,
                                                    // position: "absolute",
                                                    display: "block",
                                                    visibility: "visible",
                                                    left: 0,
                                                    top: 0
                                                }}
                                            >
                                                <sr7-bg
                                                    id="SR7_4_1-7-4"
                                                    className="sr7-layer"
                                                    data-type="shape"
                                                    data-subtype="slidebg"
                                                    style={{
                                                        padding: 0,
                                                        width: "100%",
                                                        height: 570,
                                                        display: "block",
                                                        visibility: "inherit",
                                                        pointerEvents: "none",
                                                        opacity: 1
                                                    }}
                                                >
                                                    <canvas
                                                        width={650}
                                                        height={570}
                                                        style={{
                                                            width: 650,
                                                            height: 570,
                                                            visibility: "visible",
                                                            background: "transparent",
                                                            opacity: 1
                                                        }}
                                                    />
                                                </sr7-bg>
                                            </sr7-mask>
                                            <sr7-img
                                                id="SR7_4_1-7-0"
                                                className="sr7-layer"
                                                style={{
                                                    overflow: "visible",
                                                    padding: 0,
                                                    width: 414,
                                                    height: 414,
                                                    zIndex: 6,
                                                    position: "absolute",
                                                    transformOrigin: "50% 50%",
                                                    transform: "translate(0px, 0px)",
                                                    display: "block",
                                                    background:
                                                        `url(${service?.KeyBenefits?.image}) 50% 50% / cover no-repeat transparent`,
                                                    left: 118,
                                                    top: 78,
                                                    visibility: "visible",
                                                    opacity: 1,
                                                    pointerEvents: "auto"
                                                }}
                                            />
                                           
                                        </sr7-slide>
                                        <sr7-slide
                                            id="SR7_4_1-8"
                                            data-key={8}
                                            className="sr7-staticslide sr7-staticslide-high"
                                            style={{
                                                pointerEvents: "none",
                                                display: "block",
                                                visibility: "visible"
                                            }}
                                        ></sr7-slide>
                                        <sr7-module-shadow className="sr7-shdw-0" />
                                    </sr7-content>
                                </sr7-module>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Services
